import React from 'react';

import { GuideCallout, GuideMarkdown } from '@backrs_ui/grow-ui/src/components/GuidePage';
import {
  CollegeApplicationRoadmapCallout,
  CollegeApplicationRoadmapHeader,
} from '@backrs_ui/grow-ui/src/pages/CollegeApplicationRoadmapGuide/content';

import { Box, SxProps, Theme, Typography } from '@mui/material';

type RoadmapOverviewDetailProps = Readonly<{
  header: CollegeApplicationRoadmapHeader;
  callout: CollegeApplicationRoadmapCallout;
}>;

export const RoadmapOverviewDetail: React.FC<RoadmapOverviewDetailProps> = ({
  header,
  callout,
}) => (
  <Box sx={containerSx}>
    <Typography variant="display-md-semibold" component="h1" sx={titleSx}>
      {header.title}
    </Typography>
    <Box sx={leadsSx}>
      {header.description.map((paragraph) => (
        <GuideMarkdown key={paragraph}>{paragraph}</GuideMarkdown>
      ))}
    </Box>
    <GuideCallout variant={callout.variant} title={callout.title} body={callout.body} />
  </Box>
);

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-xl'],
});

const titleSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-primary'],
  m: backrs.spacing['spacing-none'],
});

const leadsSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-lg'],
});
